import { selectors } from '../Stream';
import { getStreamId } from './helpers';
export function getTotal(state, typeId, itemId, parentId) {
    var streamId = getStreamId(typeId, itemId, parentId);
    return selectors.getTotal(state, streamId);
}
export function getThreadState(state, typeId, itemId, parentId) {
    var streamId = getStreamId(typeId, itemId, parentId);
    var streamParams = selectors.getStreamParams(state, streamId);
    return {
        streamId: streamId,
        isInitialized: selectors.isInitialized(state, streamId),
        items: selectors.getItems(state, streamId),
        hasMore: selectors.hasMore(state, streamId),
        hasLess: selectors.getHasLess(state, streamId),
        isFetching: selectors.isFetching(state, streamId),
        total: selectors.getTotal(state, streamId),
        order: streamParams && streamParams.order,
        lastInsertedCommentId: streamParams && streamParams.lastInsertedCommentId,
        canPostComment: streamParams && streamParams.canPostComment,
    };
}
//# sourceMappingURL=selectors.js.map